import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import "swiper/css";
import { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./views/dashboard";
import Login from "./views/login";
import Landing from "./views/landing";
import { Toaster } from "react-hot-toast";
import ResetPassword from "./views/reset_password";
import Signup from "./views/signup";
import Members from "./views/dashboard/members";
import Profile from "./views/dashboard/members/profile";
import Courses from "./views/courses";
import NewCourse from "./views/courses/new/index.jsx";
import EditCourse from "./views/courses/edit/index.jsx";
import ViewCourse from "./views/courses/view/index.jsx";
import Community from "./views/community";
import ViewCommunity from "./views/community/view/view_community.jsx";
import FAQs from "./views/faqs";
import Setting from "./views/setting";
import Transactions from "./views/transactions";
import Statistics from "./views/statistics";
import Coupons from "./views/coupons";
import { Provider } from "react-redux";
import { store } from "./store/store.js";

function App() {
  return (
    <Fragment>
      <Provider store={store}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset_password" element={<ResetPassword />} />
          <Route path="/signup" element={<Signup />} />

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/new" element={<NewCourse />} />
          <Route path="/courses/edit/:id" element={<EditCourse />} />
          <Route path="/courses/view/:id" element={<ViewCourse />} />
          <Route path="/community" element={<Community />} />
          <Route path="/community/:id" element={<ViewCommunity />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/setting" element={<Setting />} />
          <Route path="/transactions" element={<Transactions />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/coupons" element={<Coupons />} />

          <Route path="/dashboard/members" element={<Members />} />
          <Route path="/dashboard/members/profile" element={<Profile />} />

          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster
          position="top-center"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            duration: 5000,
          }}
        />
      </Provider>
    </Fragment>
  );
}

export default App;
